import React from "react";
import { useQuery } from "urql";
import ReadMainMenuItems from "../components/Navigation/Navigation.graphql";
import ReadMoreMenuItems from "../components/Navigation/MoreMenu/MoreMenu.graphql";

// context for providing query data to navigation components
// this is necessary to avoid multiple renders calling useQuery
// that in Offline mode can create a cache miss (not exactly sure
// how but it seems related to calling useQuery quickly and multiple times)
const Context = React.createContext([
  [{ fetching: true, error: null, data: null }],
  [{ fetching: true, error: null, data: null }],
]);

export default Context;

export function NavigationContextComponent({ children }) {
  const navigationData = useQuery({ query: ReadMainMenuItems });
  const moreMenuData = useQuery({ query: ReadMoreMenuItems });
  return (
    <Context.Provider value={[navigationData, moreMenuData]}>
      {children}
    </Context.Provider>
  );
}
